<template>
    <FontAwesomeIcon
        class="uik-icon"
        :icon="getIcon"
    />
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

export default {
    name: "UikIcon",
    components: { FontAwesomeIcon },
    props: {
        icon: { type: [String, Array], default: "" },
        type: { type: String, default: "" }
    },
    data () {
        return {
            activeType: ""
        }
    },
    computed: {
        getIcon () {
            if (Array.isArray(this.icon)) return this.icon
            return [ this.activeType, this.icon ]
        }
    },
    created () {
        this.setType()
    },
    methods: {
        setType () {
            this.activeType = this.getType() || "far"
        },
        getType () {
            return this.type || this.$root?._data?.uik?.icon?.type
        }
    }
}
</script>
